import React, { FC } from 'react'
import styled from 'styled-components'

const Content = styled.div`
  margin-top: 26px;
  max-width: 1920px;
  padding: 0;
`

interface PremiumLandingSectionProps {
  sectionTitle: React.ReactNode
  className?: string
}

const PremiumLandingSection: FC<
  React.PropsWithChildren<PremiumLandingSectionProps>
> = ({ sectionTitle, children, className }) => {
  return (
    <>
      {sectionTitle}
      <Content className={className}>{children}</Content>
    </>
  )
}

export default PremiumLandingSection
